import { render, staticRenderFns } from "./WonderOpportunityMining.vue?vue&type=template&id=545b7246&scoped=true"
import script from "./WonderOpportunityMining.vue?vue&type=script&lang=js"
export * from "./WonderOpportunityMining.vue?vue&type=script&lang=js"
import style0 from "./WonderOpportunityMining.vue?vue&type=style&index=0&id=545b7246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b7246",
  null
  
)

export default component.exports